"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var logo_1 = require("../../../constants/img/logo");
var OpLogo = function (_a) {
    var link = _a.link, height = _a.height;
    var onClick = function () {
        if (link) {
            location.href = '/';
        }
    };
    return ((0, preact_1.h)("button", { onClick: onClick, class: 'preact-btn op-logo-btn' },
        (0, preact_1.h)("img", { src: logo_1.OP_LOGO_GRAY, alt: 'O Positiv', class: 'op-logo-btn__img', style: height ? "height: ".concat(height, "px") : '' })));
};
exports.default = OpLogo;
